import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import ContactComponent from "./ContactComponent";

const ContactPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Консультації | Yellow Hub</title>
        <meta
          name="description"
          content="Кар'єрні консультації Yellow Hub: вибір консультантки, заявка на консультацію, підтримка з резюме, співбесідою та пошуком роботи."
        />
        <meta property="og:title" content="Кар'єрні консультації - Yellow Hub" />
        <meta
          property="og:description"
          content="Оберіть консультантку та залиште заявку. Допоможемо з резюме, співбесідою, пошуком роботи або зміною професійного напряму."
        />
        <meta property="og:url" content="https://yellowhub.com.ua/consultations" />
        <meta property="og:type" content="website" />
      </Helmet>
      <ContactComponent />
    </Fragment>
  );
};

export default ContactPage;
